export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.8.10-1413.29",
  commitId: "0d802dd20b36d4f3b254fc927c43b8c3d3a5ee52",
  commitTime: "2026-08-10T14:13:29.000Z",
});
